import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconButtonProps } from './types'
import { SpinnerIcon } from 'components/Icons/SpinnerIcon'

const BaseIconButton = styled.button<{ smallPadding?: boolean }>`
  align-items: center;
  background-color: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  transition: background-color 0.2s;
`

export const OutlineIconButton = styled(BaseIconButton)<{ noBorder?: boolean; smallPadding?: boolean }>`
  border: ${({ noBorder }): string => (noBorder ? 'none' : '1px solid #916ee8')};
  padding: ${({ smallPadding }): string => (smallPadding ? '12px 4px' : '11px 19px')};

  svg {
    fill: #916ee8;
  }

  &:hover {
    background-color: #f4f0ff;
  }

  &:active {
    background-color: #e0d6ff;
  }

  &:focus {
    background-color: #e0d6ff;
    border: 1px solid #916ee8;
    ${({ noBorder, smallPadding }): string | undefined => {
      if (noBorder) {
        return `
          padding: ${smallPadding ? '11px 3px' : '10px 18px'}; 
        `
      }
    }}
  }

  &:disabled {
    background-color: transparent;
    border: ${({ noBorder }): string => (noBorder ? 'none' : '1px solid #e3e3e3')};
    cursor: not-allowed;

    svg {
      fill: #e3e3e3;
    }
  }
`

const IconContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  color: #916ee8;
  font-size: 14px;
  font-weight: 400;
`

const IconButton = ({ icon, noBorder, smallPadding, loading, children, ...props }: IIconButtonProps): ReactElement => {
  return (
    <OutlineIconButton type="button" noBorder={noBorder} smallPadding={smallPadding} {...props}>
      {loading ? (
        <SpinnerIcon />
      ) : (
        <IconContainer>
          {icon}
          {children}
        </IconContainer>
      )}
    </OutlineIconButton>
  )
}

export default IconButton
